import React from "react";
import LoadingInput from "../../../../_components/LoadingInput";
import Text from "../../../../_components/Text";
import { getChartOfAccounts } from "../../../../api/openFinance";

export default function ChartOfAccountsInput(props) {
  const [loading, setLoading] = React.useState(false);
  const [accounts, setAccounts] = React.useState([]);

  function onInit() {
    setLoading(true);
    getChartOfAccounts()
      .then((data) => {
        // Formatar para hierarquia baseada no code (ex: 1, 1.1, 1.1.1)
        // O backend retorna uma lista plana. Vamos ordernar pelo code.
        const sortedData = data.sort((a, b) => {
          if (!a.code || !b.code) return 0;
          return a.code.localeCompare(b.code);
        });
        setAccounts(sortedData);
      })
      .catch((error) => {
        console.error("Erro ao buscar plano de contas", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  React.useEffect(onInit, []);

  function onChange(e) {
    if (props.onChange) {
      props.onChange({
        target: { name: "chart_of_account_id", value: e.target.value },
      });
    }
  }

  function getIndentation(code) {
    if (!code) return "";
    const depth = code.split(".").length - 1;
    if (depth === 0) return "";
    let indent = "";
    for (let i = 0; i < depth; i++) {
      indent += "    "; // 4 spaces
    }
    return indent + "|_ ";
  }

  return (
    <React.Fragment>
      <Text color="primary">{props.title || "Plano de contas*"}</Text>
      <LoadingInput
        name="chart_of_account_id"
        onChange={onChange}
        loading={loading}
        as="select"
        value={props.selected || ""}
        disabled={props.disabled}
        className="form-control"
      >
        <option value="" disabled>
          -- Selecione --
        </option>
        {accounts.map((acc) => (
          <option key={acc.id} value={acc.id}>
            {getIndentation(acc.code)}
            {acc.name}
          </option>
        ))}
      </LoadingInput>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/ChartOfAccountsInput/index.jsx